import { FrameName } from "../config";
import TileEntity from "../TileEntity";

class WoodenBridgeTileEntity1 extends TileEntity {
	public static readonly frameName = FrameName.WOODEN_BRIDGE_1;
}

export default WoodenBridgeTileEntity1;
